import { useDataChange, useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let treatment_id = useDataValue({
    context: 'treatment',
    path: 'id',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.treatment_id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(treatment_id)
    submit({ type: 'close_popover' })
  }
}
